import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedAssessmentId: null,
};

const assessmentSlice = createSlice({
  name: 'assessment',
  initialState,
  reducers: {
    setSelectedAssessmentId: (state, action) => {
      state.selectedAssessmentId = action.payload;
    },
    resetAssessmentState: (state) => {
      state.selectedAssessmentId = null;
    },
  },
});

export const { setSelectedAssessmentId,resetAssessmentState } = assessmentSlice.actions;

export default assessmentSlice.reducer;